/**
 * @name 쿼리 키
 * @description [keyName,params1,params2...]
 * @param keyName 서비스ID_목록or상세_타입_구분1_구분2...
 * @param paramsN api params 고정 값 사용하는 경우 작성
 */
export const E_QUERY_KEY = {
  PRODUCT_LIST_FIX_LEAFLET_LIST: ['PRODUCT_LIST_FIX_LEAFLET_LIST'],
  PRODUCT_LIST_LEAFLETLIST: ['PRODUCT_LIST_LEAFLETLIST'],
  PRODUCT_LIST_LEAFLETMEMU: ['PRODUCT_LIST_LEAFLETMEMU'],
  PRODUCT_DETAIL_LEAFLET: ['PRODUCT_DETAIL_LEAFLET'],
};
